/**
 * Format a date/time string to EST timezone
 *
 * @param dateString - ISO 8601 date string or any valid date string
 * @param includeTime - Whether to include time in the output (default: true)
 * @returns Formatted date string in EST
 */
export function formatToEST(dateString: string | null | undefined, includeTime = true): string {
  if (!dateString) return '-';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  // Format in EST timezone
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
    options.second = '2-digit';
    options.hour12 = true;
  }

  return date.toLocaleString('en-US', options);
}

/**
 * Format a date/time string to EST with a shorter format
 * Example: "1/15/25, 2:30:45 PM"
 */
export function formatToESTShort(dateString: string | null | undefined): string {
  if (!dateString) return '-';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}

/**
 * Get the current date/time in EST
 */
export function nowInEST(): Date {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
}
